import React, { useState } from "react";
import axios from "axios";
import {
  Grid,
  makeStyles,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import LoadingIndicator from "./LoadingIndicator";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },

  labelHeight: {
    fontSize: "0.7rem",
    padding: `${theme.spacing(1)}px 0px`,
  },

  dateTextField: {
    width: 100,
    margin: 0,
    "& .MuiInputBase-root": {
      padding: `0px ${theme.spacing(1)}px`,
      fontSize: "0.7rem",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: `0px ${theme.spacing(1)}px`,
    },
  },

  textField: {
    width: 200,
    margin: 0,
    "& .MuiInputBase-root": {
      padding: `4px ${theme.spacing(0)}px`,
      fontSize: "1rem",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: `0px ${theme.spacing(1)}px`,
    },
  },
  headerStyle: {
    marginLeft: "8px",
    margingBottom: "4px",
    marginTop: "4px",
    // backgroundColor: "#e3f2fd",
    backgroundColor: "#e2efd9",
  },
}));

const UnreconcileSubmit = ({
  selectedRows,
  setSelectedRows,
  openPopup,
  setOpenPopup,
  reconciledBy,
  handleSearchFormSubmit,
  unreconcileSubmitDataUrl,
  createNetInspectionApiClient,
  minDate,
  dateIsGreaterThanMinDate,
  setDisableEditPaymentBtn,
  setDisableReconcileButton,
  setDisableUnreconcileButton,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [errors, setErrors] = useState([]);

  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  // const handleDepositDateChange = (event) => {
  //   event.preventDefault();
  // };

  const unreconcilePostDataURL = unreconcileSubmitDataUrl();

  const postUnreconcileData = async (dataToPost) => {
    try {
      setLoading(true);
      let baseUrl = `${unreconcilePostDataURL}`;

      let response = await createNetInspectionApiClient().post(
        `${baseUrl}`,
        dataToPost
      );
      setLoading(false);
      // after successful  refresh the search fields data
      if (response && (response.data ?? "false").toLowerCase() === "true") {
        enqueueSnackbar("Unreconcile records submitted successfully!", {
          variant: "success",
        });

        setOpenPopup(false);
        setSelectedRows([]);
        setDisableEditPaymentBtn(true);
        setDisableReconcileButton(true);
        setDisableUnreconcileButton(true);
        handleSearchFormSubmit();
      } else {
        enqueueSnackbar(
          "An error occured while processing, please submit later!",
          {
            variant: "error",
          }
        );
      }
      // set the local state data
    } catch (err) {
      setLoading(false);
      enqueueSnackbar(
        (err && err.message) || "Oops! Something went wrong. Please try again!",
        { variant: "error" }
      );
    } finally {
      //   console.log("post reconcile completd");
    }
  };

  const dataIsValid = () => {
    if (selectedRows.length === 0) {
      return false;
    }
    setErrors([]);
    let tmpErrors = [];

    // Check all rows are already reconciled
    selectedRows.map((row) => {
      if (!row.reconcile_id || row.reconcile_id <= 0) {
        tmpErrors.push(
          "Only reconciled records should be selected for unreconciling!"
        );
      }
    });

    if (tmpErrors && tmpErrors.length && tmpErrors.length > 0) {
      setErrors(tmpErrors);
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (dataIsValid) {
      let reconcileRecordData = [];
      selectedRows.map((row) => {
        if (row.reconcile_id) {
          reconcileRecordData.push({
            reconcile_id: row.reconcile_id,
          });
        }
      });

      if (reconcileRecordData.length > 0) {
        // post data
        await postUnreconcileData(reconcileRecordData);
      }
    } else {
      if (selectedRows.length === 0) {
        enqueueSnackbar("No data to process", { variant: "error" });
        return;
      } else if (selectedRows.length > 0) {
        enqueueSnackbar(
          "Invalid data for Unrecilliation, please submit only reconciled records",
          { variant: "error" }
        );
        return;
      }
    }

    // console.log(JSON.stringify(reconcileRecordData));
  };

  let renderError;
  if (errors && errors.length && errors.length > 0) {
    renderError = (
      <>
        <ShowErrors errors={errors} />{" "}
      </>
    );
  }

  let content;

  if (loading) {
    content = <LoadingIndicator />;
  } else {
    content = content = (
      <>
        <TableContainer component={Paper}>
          <Table
            style={{
              border: "1px solid black",
              borderCollapse: "collapse",
              width: "800px",
            }}
          >
            <TableHead style={{ backgroundColor: "InfoBackground" }}>
              <TableRow>
                <TableCell>Reconcile Status</TableCell>
                <TableCell>Cert#</TableCell>
                <TableCell>InspectionType</TableCell>
                <TableCell>ReconciledBy</TableCell>
              </TableRow>
            </TableHead>
            {selectedRows.length > 0 && (
              <TableBody>
                {selectedRows.map((row) => {
                  return (
                    <TableRow key={row.reconcile_id}>
                      <TableCell>{row.reconciled_status}</TableCell>
                      <TableCell>{row.certificate_number}</TableCell>
                      <TableCell>{row.inspection_type}</TableCell>
                      <TableCell>{row.reconciled_by_user}</TableCell>
                      {/* <TableCell>
                          {convertIsoDateStringToReglarDateString(
                            row.payment_date
                          )}
                        </TableCell> */}
                    </TableRow>
                  );
                })}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <div
          style={{
            width: "800px",
            display: "flex",
            justifyContent: "center",
            spacing: "10px",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            style={{
              width: "80px",
              height: "20px",
              fontSize: "0.8rem",
              padding: "8px",
              margin: "10px",
            }}
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </Button>

          <Button
            color="primary"
            variant="contained"
            style={{
              width: "80px",
              height: "20px",
              fontSize: "0.8rem",
              padding: "8px",
              margin: "10px",
            }}
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            Close
          </Button>
        </div>
      </>
    );
  }

  return <> {content}</>;
};

export default UnreconcileSubmit;
